export default __webpack_public_path__ + "static/media/0061.70d7b11a.png";